import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import GoogleTranslateWidget from '../../../../components/GoogleTranslateWidget';
export function BlogPostNarcissismGaslightingKO() {
  const articleData = {
    title: '용어에 대해 알아보기: 나르시시즘과 가스라이팅',
    description: '나르시시즘이나 가스라이팅 행동에 혼란스러우신가요? 텍스트의 주요 징후를 배우고 Toxic Detector의 AI가 미묘한 조작 패턴을 즉시 식별하는 방법을 확인하세요.',
    slug: 'narcissism-gaslighting-explained',
    publishDate: '2025-07-15',
    author: 'Toxic Detector Editorial'
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-8168" data-mp="3hetny7q4pthw">
      <GoogleTranslateWidget data-id="element-8169" data-mp="3hf3fhzqto8pp" />
      <Helmet data-id="element-8170" data-mp="3hgxpij0k2gf0">
        <title data-id="element-8171" data-mp="3lfx30s0crli2">나르시시즘과 가스라이팅 설명 | ToxicDetector</title>
        <meta name="description" content="나르시시즘과 가스라이팅 조작 전략 뒤에 있는 심리학을 이해합니다." data-id="element-8172" data-mp="3lfncn3bebcbu" />
        <meta name="keywords" content="나르시시즘, 가스라이팅, 조작, 심리학, AI 분석" data-id="element-8173" data-mp="37oi9hr8tk1wr" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/iLMUMmEFFWiRSqv8DSTAdz/file_00000000f0c8720a9c4e7f9e2fbdea6d.png" data-id="element-8174" data-mp="3cm0ex7nmnz00" />
        <link rel="canonical" href={`https://toxicdetector.com/ko/blog/${articleData.slug}`} data-id="element-8175" data-mp="32qgnaxg3jmh2" />
        <script type="application/ld+json" data-id="element-8176" data-mp="2orz4ne51t060">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BlogPosting',
          headline: '나르시시즘과 가스라이팅 설명',
          description: '나르시시즘이나 가스라이팅 행동에 혼란스러우신가요? 텍스트의 주요 징후를 배우고 Toxic Detector의 AI가 미묘한 조작 패턴을 즉시 식별하는 방법을 확인하세요.',
          image: 'https://toxicdetector.com/ko/blog/narcissism-gaslighting-explained.jpg',
          author: {
            '@type': 'Person',
            name: 'Toxic Detector Editorial'
          },
          publisher: {
            '@type': 'Organization',
            name: 'ToxicDetector',
            logo: {
              '@type': 'ImageObject',
              url: 'https://toxicdetector.com/logo.png'
            }
          },
          datePublished: '2025-07-15',
          dateModified: '2025-07-15'
        })}
        </script>
      </Helmet>

      <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-8177" data-mp="zgveer0m3pp2">
        <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-8178" data-mp="uibwr2t1x02i">
          <div className="flex items-center justify-between" data-id="element-8179" data-mp="uhsc3ec0nxks">
            <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-8180" data-mp="1rxpsur4zwki5">
              🚩 ToxicDetector
            </Link>
            <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Share article" data-id="element-8181" data-mp="1ui46khufr05o">
              <Share2 size={20} className="text-gray-600" data-id="element-8182" data-mp="24g1wd9ry150e" />
            </button>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-8183" data-mp="29feqmfl59ed0">
        <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-8184" data-mp="29csb9ts0huk8">
          <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8185" data-mp="2ie8la0ewzunx" />
          블로그로 돌아가기
        </Link>

        <header className="mb-12" data-id="element-8186" data-mp="2s5w45cxeo3ds">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-8187" data-mp="2s5338sl4o83k">
            {articleData.title}
          </h1>
          <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-8188" data-mp="315sy9u2kdug8">
            <time dateTime={articleData.publishDate} data-id="element-8189" data-mp="313yggomlaigd">
              {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </time>
            <span className="text-gray-300" data-id="element-8190" data-mp="bhlj99ouvlgd">•</span>
            <span data-id="element-8191" data-mp="7grphzoqfcfk">{articleData.author}</span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none" data-id="element-8192" data-mp="7ivwiqhxgrk2">
          <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-8193" data-mp="3fx4gxbaaqc15">
            왜 일부 사람들이 관계에서 당신을 혼란스럽게 하고, 지치게 하고,
            자신을 의심하게 만드는지 궁금한 적이 있나요? 그것은 종종{' '}
            <strong data-id="element-8194" data-mp="3oxj3edyzxx68">나르시시즘과 가스라이팅</strong>이 작용하고 있습니다.
          </p>

          <section className="mb-12" data-id="element-8195" data-mp="3ouwzqpf881ta">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8196" data-mp="3jxev3b88s8r3">
              나르시시즘이란 무엇인가요?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8197" data-mp="145he08uv73ai">
              <strong data-id="element-8198" data-mp="z8h41muw9ge4">나르시시즘</strong>은 자기중심적이고 조작적인 행동
              패턴으로, 다른 사람보다 자신의 필요를 우선시합니다.
            </p>
          </section>

          <section className="mb-12" data-id="element-8199" data-mp="17n51jr8uzdd8">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8200" data-mp="1bqbh5phv2gwd">
              가스라이팅이란 무엇인가요?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8201" data-mp="xrbrceim3vym">
              <strong data-id="element-8202" data-mp="12plp8wvq1anx">가스라이팅</strong>은 당신 자신의 현실, 기억 또는 감정을
              의심하게 만드는 심리적 조작 기술입니다.
            </p>
          </section>

          <section className="mb-12" data-id="element-8203" data-mp="1qextrjg3sujw">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8204" data-mp="1qfzeygqu2xfc">
              AI가 이러한 패턴을 감지하는 방법
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8205" data-mp="1gpo0w1dfr7uq">
              추측하는 대신, 우리의 AI는 조작 패턴을 위해 대화를 분석합니다.
            </p>
          </section>

          <section className="mb-12" data-id="element-8206" data-mp="1lmmu8hp9zarv">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8207" data-mp="29ebrmcgyepfo">
              이것을 이해하는 것이 중요한 이유
            </h2>
            <p className="text-lg leading-relaxed text-gray-600" data-id="element-8208" data-mp="2e5trsyb5klzl">
              <strong data-id="element-8209" data-mp="2o0il4pyqra0y">나르시시즘</strong> 또는 <strong data-id="element-8210" data-mp="2o10mg109gefq">가스라이팅</strong>을
              조기에 인식하면 정서적 건강을 보호합니다.
            </p>
          </section>
        </div>

        <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-8211" data-mp="2j27baf8g4ziq">
          <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-8212" data-mp="2e19tw4v9g9ia">
            💀 진실을 볼 준비가 되셨나요?
          </h2>
          <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-8213" data-mp="2a0g5ladwosov">
            추측을 멈추세요. Toxic Detector에 텍스트를 업로드하고 즉시 독성
            점수를 받으세요.
          </p>
          <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-8214" data-mp="20a50hkihkdge">
            지금 채팅 스캔하기 →
          </Link>
        </div>

        <div className="mt-16" data-id="element-8215" data-mp="1qb5q9xi2o9ra">
          <RelatedBlogPosts posts={[{
          title: '가스라이팅의 7가지 징후',
          description: 'AI가 텍스트 대화에서 감지하는 주요 가스라이팅 패턴을 배웁니다.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: '당신의 전 애인은 은밀한 나르시시스트인가요?',
          description: '텍스트 분석을 통해 전 애인이 은밀한 나르시시즘 행동의 징후를 보이는지 확인하세요.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-8216" data-mp="1mbwvqqf7k7uo" />
        </div>
      </article>

      <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-8217" data-mp="3a9z4eaj6vjf3">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-8218" data-mp="3earfl9bmfye0">
          <p className="text-gray-500 text-sm" data-id="element-8219" data-mp="3eb156vsr83j6">
            © {new Date().getFullYear()} ToxicDetector. 모든 권리 보유.
          </p>
        </div>
      </footer>
    </div>;
}